export { default } from './StoreBadge';
